import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Ecosystem from "@/pages/Ecosystem";

export const Route = createFileRoute("/en/about-qbd/ecosystem")({
  head: () => buildRouteHead("/en/about-qbd/ecosystem"),
  component: Ecosystem,
});

